import { LOCALE_ID, NgModule } from '@angular/core';
import { CartAdapter } from '@spartacus/cart/base/core';
import { OccCartAdapter } from '@spartacus/cart/base/occ';
import { MultiCartFacade } from '@spartacus/cart/base/root';
import { AuthConfig, I18nConfig, OccConfig, PageLinkService, PageMetaConfig, SiteContextConfig, UserAddressAdapter, provideConfig, provideFeatureToggles } from '@spartacus/core';
import { OrderModule } from '@spartacus/order';
import { SmartEditConfig } from '@spartacus/smartedit/root';
import { MediaConfig, ViewConfig, defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { UserProfileFacade, UserRegisterFacade } from '@spartacus/user/profile/root';
import { customTranslationChunksConfig } from '../../../public/translations/custom-translation-chunks-config';
import { environment } from '../../environments/environment';
import { CustomOccRealtimeStockAdapter } from '../custom/cart/realtime-stock/adapter/custom-realtime-stock.adapter';
import { CustomRealtimeStockAdapter } from '../custom/cart/realtime-stock/conectors/custom-realtime-stock.adapter';
import { CustomOccUnavailableProductsAdapter } from '../custom/cart/unavailable-products/adapter/custom-unavailable-products.adapter';
import { CustomUnavailableProductsAdapter } from '../custom/cart/unavailable-products/connectors';
import { CustomOccCategoryAdapter } from '../custom/cms-components/content/custom-header-category/adapter/custom-category.adapter';
import { CustomCategoryAdapter } from '../custom/cms-components/content/custom-header-category/conectors';
import { CustomOccFamiliesAdapter } from '../custom/cms-components/families/custom-families/adapter/custom-families.adapter';
import { CustomFamiliesAdapter } from '../custom/cms-components/families/custom-families/conectors';
import { CustomOccDocumentIdentifierValidatorAdapter } from './custom/cms-components/myaccount/custom-tickets/adapter/custom-document-identifier-validator.adapter';
import { CustomOccTicketsAdapter } from './custom/cms-components/myaccount/custom-tickets/adapter/custom-tickets.adapter';
import { CustomDocumentIdentifierValidatorAdapter } from './custom/cms-components/myaccount/custom-tickets/conectors/custom-document-identifier-validator.adapters';
import { CustomTicketsAdapter } from './custom/cms-components/myaccount/custom-tickets/conectors/custom-tickets.adapters';
import { CustomOccWishlistAdapter } from './custom/cms-components/myaccount/custom-wishlist/adapter/custom-wishlist.adapter';
import { CustomWishlistAdapter } from './custom/cms-components/myaccount/custom-wishlist/conectors/whislist.adapter';
import { CustomInvoiceAdapter } from './custom/cms-components/myaccount/invoices/connectors/custom-invoice.adapter';
import { CustomOccInvoicesAdapter } from './custom/cms-components/myaccount/invoices/connectors/custom-occ-invoices.adapter';
import { CustomCartAdapter } from './custom/core/cart/adapter/custom-cart.adapter';
import { customPageMetaConfig } from './custom/core/cms/page/config/custom-page-meta.config';
import { CustomPageLinkService } from './custom/core/cms/page/routing/custom-page-link.service';
import { CustomOccUserAddressAdapter } from './custom/core/occ/adapters/adapter/custom-occ-user-address.adapter';
import { CustomUserAddressAdapter } from './custom/core/occ/adapters/adapter/custom-user-address.adapter';
import { CustomOccCartAdapter } from './custom/core/occ/adapters/cart/custom-occ-cart.adapter';
import { CustomOccCheckoutPaymentTypeAdapter } from './custom/core/occ/adapters/checkout/custom-occ-checkout-payment-type.adapter';
import { CustomOccUserOrderAdapter } from './custom/core/occ/adapters/order/custom-occ-user-order.adapter';
import { CustomOccSiteAdapter } from './custom/core/occ/adapters/site-context/custom-occ-site.adapter';
import { CustomProductModule } from './custom/core/product';
import { ActiveCartService } from './custom/core/src/cart/facade/custom-active-cart.service';
import { CustomMultiCartService } from './custom/core/src/cart/facade/custom-multi-cart.service';
import { CustomPaymentTypeAdapter } from './custom/core/src/checkout/connectors/custom-payment-type.adapter';
import { CustomCheckoutModule } from './custom/core/src/checkout/custom-checkout.module';
import { CustomOccStoreFinderAdapter } from './custom/core/storefinder/connectors/custom-occ-store-finder.adapter';
import { CustomStoreFinderAdapter } from './custom/core/storefinder/connectors/custom-store-finder.adapter';
import { CustomUserOrderAdapter } from './custom/core/user/connectors/order/custom-user-order.adapter';
import { CustomSiteAdapter } from './custom/core/user/connectors/site-context/connectors/custom-site.adapter';
import { CustomCheckoutStepType } from './features/tracking/custom-events/checkout/checkout-steps/custom-checkout-steps.model';
import { CustomUserProfileAdapter } from './features/user/profile/custom-register/store/conectors/custom-user-profile.adapter';
import { CustomOccUserProfileAdapter } from './features/user/profile/occ/adapters/custom-occ-user-profile.adapter';
import { CustomUserProfileFacade } from './features/user/profile/root/facade/custom-user-profile.facade';
import { CustomUserProfileService } from './features/user/profile/root/facade/custom-user-profile.service';
import { CustomUserRegisterFacade } from './features/user/profile/root/facade/custom-user-register.facade';
import { CustomUserRegisterService } from './features/user/profile/root/facade/custom-user-register.service';

@NgModule({
  declarations: [],
  imports: [CustomCheckoutModule.forRoot(), CustomProductModule.forRoot(), OrderModule],
  providers: [
    provideConfig(customPageMetaConfig as PageMetaConfig),
    provideConfig(layoutConfig),
    provideConfig({
      ...mediaConfig,
      mediaFormats: {
        mobile: { width: 400 },
        tablet: { width: 770 },
        desktop: { width: 1140 },
        widescreen: { width: 1400 }
      }
    } as MediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      view: {
        defaultPageSize: 24
      }
    } as ViewConfig),
    provideConfig({
      backend: {
        media: {
          baseUrl: environment.mediaBaseUrl
        },
        occ: {
          baseUrl: environment.occBaseUrl,
          prefix: '/spartacus/v2/',
          endpoints: {
            // TODO:jdk21 remove "component(s)" "page(s)" after backend upgrade
            component: 'cms/components/${id}',
            components: 'cms/components',
            pages: 'cms/pages',
            page: 'cms/pages/${id}',

            product: {
              list: 'products/${productCode}?fields=FULL',
              list_item: 'products/${productCode}?fields=DEFAULT,stock(FULL),price(DEFAULT),images(DEFAULT),categoryTags,manufacturer,promotions(DEFAULT)',
              details: 'products/${productCode}?fields=FULL',
              attributes: 'products/${productCode}?fields=FULL',
              variants: 'products/${productCode}?fields=FULL'
            },
            user: 'users/${userId}?fields=FULL',
            newsLetter: '/users/${userId}/newsletter',
            setCartPaymentType: '/users/${userId}/carts/${cartId}/paymentMode',
            paymentModes: '/users/${userId}/carts/${cartId}/paymentmodes',
            redsysPayment: 'users/${userId}/carts/${cartId}/payments/redsys/hop',
            sequraPayment: 'users/${userId}/carts/${cartId}/payments/sequra/hop?paymentMethod=${paymentMethod}',
            paypalPayment: 'users/${userId}/carts/${cartId}/paypal/createpayment',
            // tslint:disable-next-line:max-line-length
            paypalCreateOrder: 'users/${userId}/carts/${cartId}/paypal/acceptorder?paymentId=${paymentId}&token=${token}&PayerID=${PayerID}',
            families: 'category/${code}/families?fields=FULL',
            category: 'cms/category/${code}?fields=FULL',
            getWishlist: '/users/${userId}/wishlist?fields=DEFAULT,entries(product(FULL))',
            createWishlist: '/users/${userId}/wishlist/entries/${productCode}',
            carts:
              'users/${userId}/carts?fields=carts(FULL,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL),stockMessage),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue, value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description)',
            cart: 'users/${userId}/carts/${cartId}?fields=FULL,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL),stockMessage),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,amountForFreeDelivery,possibleFreeDelivery,freeDelivery,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue, value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description',
            countriesAll: 'countries',
            orderHistory: '/users/${userId}/arcERPOrders?fields=FULL',
            orderDetail: 'users/${userId}/orders/${orderId}?fields=FULL',
            myAccountOrderDetail: '/users/${userId}/arcERPOrders/${orderId}?fields=FULL',
            setOrderChecked: 'users/${userId}/orders/${orderId}/checked?fields=BASIC',
            orderStatusList: 'statuses',
            orderRestoration: '/users/${userId}/carts/${cartId}/orders/${code}/restoration',
            invoices: '/users/${userId}/invoices',
            validateRealtimeStock: 'users/${userId}/carts/${cartId}/realtimestock?fields=FULL',
            unavailableProducts: 'users/${userId}/carts/${cartId}/unavailableProducts?fields=FULL',
            notifyMe: '/users/${userId}/productinterests',
            getProductInterests: 'users/${userId}/productinterests?fields=FULL',
            addAnonProductInterests: 'users/${userId}/anonproductinterests',
            tickets: '/users/${userId}/support-tickets?',
            ticketsCategories: '/ticket-categories',
            addTicket: '/users/${userId}/add-support-ticket',
            getTicket: '/users/${userId}/support-ticket/${ticketId}',
            productSearch:
              'products/search?fields=products(code,name,normalizedName,summary,configurable,configuratorType,price(FULL),images(DEFAULT),stock(FULL),averageRating,variantOptions,manufacturer,categoryTags,categories(DEFAULT)),facets,breadcrumbs,showBreadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery,categoryBottomLongDescription,categoryMetaDescription,categoryCanonicalUrl,categoryMetaTitle,title,categoryLongDescription',
            getModifiedProducts: 'users/${userId}/carts/${cartId}/modifiedQuantityEntries',
            documentIdentifierValidator: '/documentidentifiervalidator',
            addressCustomUpdate: '/users/${userId}/addresses/${addressId}',
            workWithUs: '/users/${userId}/ohgarWorkPetition',
            ticketsCompanyCategories: '/attentionCompanyTypes',
            attentionCompany: '/users/${userId}/attentionCompanyPetition',
            validateOrderAndEmail: '/users/${userId}/validateOrderAndEmail',
            anonProductInterests: '/users/${userId}/anonproductinterests',
            stores:
              'stores?fields=stores(name,displayName,description,openingHours(name,weekDayOpeningList(FULL),specialDayOpeningList(FULL)),geoPoint(latitude,longitude),address(line1,line2,town,region(FULL),postalCode,phone,country,email), features),pagination(DEFAULT),sorts(DEFAULT)',
            validateRecaptcha: '/verify-recaptcha/verify?gRecaptchaResponse=${gRecaptchaResponse}',
            productReferences: 'products/${productCode}/references?fields=DEFAULT,references(target(images(FULL),categoryTags))&referenceType=${referenceType}',
            deliveryZones: '/users/${userId}/carts/${cartId}/deliveryZones?zone=${zone}',
            regionsZone: 'countries/${isoCode}/regions?fields=regions(name,isocode,isocodeShort)&zone=${zone}',
            addressesZone: '/users/${userId}/addresses?zone=${zone}',
            deliveryModes: '/users/${userId}/carts/${cartId}/deliverymodes',
            cleanCartPaymentAddress: '/users/${userId}/carts/${cartId}/cleanCartPaymentAddress'
          },
          useWithCredentials: true
        }
      },
      pwa: {
        enabled: false
      },

      checkout: {
        guest: true,
        // You must specify all of the steps (this configuration is not merged with the default one)
        steps: [
          {
            id: 'shippingAddress',
            name: 'checkoutProgress.shippingAddress',
            routeName: 'checkoutShippingAddress',
            type: [CustomCheckoutStepType.SHIPPING_ADDRESS]
          },
          {
            id: 'paymentDetails',
            name: 'checkoutProgress.paymentDetails',
            routeName: 'checkoutPaymentDetails',
            type: [CustomCheckoutStepType.PAYMENT_DETAILS]
          },
          {
            id: 'paymentType',
            name: 'checkoutProgress.methodOfPayment',
            routeName: 'checkoutPaymentType',
            type: [CustomCheckoutStepType.PAYMENT_TYPE]
          }
        ]
      }
    } as OccConfig),
    provideConfig(<AuthConfig>{
      authentication: {
        client_id: 'ohgar-dev_public',
        baseUrl: environment.occBaseUrl + '/authorizationserver'
      }
    }),
    // provideConfig({
    //   authentication: {
    //     client_id: 'ohgar',
    //     client_secret: 'secret'
    //   }
    // } as AuthConfig),
    provideConfig({
      context: {
        baseSite: ['ohgar'],
        currency: ['EUR'],
        language: ['es', 'en', 'pt'],
        urlParameters: ['language']
      }
    } as SiteContextConfig),
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: customTranslationChunksConfig,
        fallbackLang: 'en',
        backend: {
          loader: (lng: string, ns: string) => import(`../../../public/translations/${lng}/${ns}.json`)
        }
      }
    }),
    provideConfig({
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        allowOrigin:
          'localhost:9002,*.*.model-t.cc.commerce.ondemand.com:443,backoffice.adiberia.com:443,s1-backoffice.adiberia.com:443,static.cloudflareinsights.com:443,qualtrics.com:443'
      }
    } as SmartEditConfig),
    provideFeatureToggles({
      authorizationCodeFlowByDefault: true,
      incrementProcessesCountForMergeCart: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      cdsLoginEventsToken: true,
      enableCartReloadOnContextChange: true,
      a11yKeyboardAccessibleZoom: false
    }),
    {
      provide: CustomPaymentTypeAdapter,
      useClass: CustomOccCheckoutPaymentTypeAdapter
    },
    {
      provide: CustomUserProfileAdapter,
      useClass: CustomOccUserProfileAdapter
    },
    {
      provide: UserRegisterFacade,
      useClass: CustomUserRegisterService
    },
    {
      provide: CustomUserRegisterFacade,
      useClass: CustomUserRegisterService
    },
    {
      provide: MultiCartFacade,
      useExisting: CustomMultiCartService
    },
    {
      provide: UserProfileFacade,
      useClass: CustomUserProfileService
    },
    {
      provide: CustomUserProfileFacade,
      useClass: CustomUserProfileService
    },
    {
      provide: CustomFamiliesAdapter,
      useClass: CustomOccFamiliesAdapter
    },
    {
      provide: CustomCategoryAdapter,
      useClass: CustomOccCategoryAdapter
    },
    {
      provide: CustomRealtimeStockAdapter,
      useClass: CustomOccRealtimeStockAdapter
    },
    {
      provide: CustomUnavailableProductsAdapter,
      useClass: CustomOccUnavailableProductsAdapter
    },
    {
      provide: CustomWishlistAdapter,
      useClass: CustomOccWishlistAdapter
    },
    {
      provide: CustomSiteAdapter,
      useClass: CustomOccSiteAdapter
    },
    {
      provide: CustomSiteAdapter,
      useClass: CustomOccSiteAdapter
    },
    {
      provide: CustomUserOrderAdapter,
      useClass: CustomOccUserOrderAdapter
    },
    {
      provide: CustomInvoiceAdapter,
      useClass: CustomOccInvoicesAdapter
    },
    {
      provide: CustomTicketsAdapter,
      useClass: CustomOccTicketsAdapter
    },
    {
      provide: CustomDocumentIdentifierValidatorAdapter,
      useClass: CustomOccDocumentIdentifierValidatorAdapter
    },
    {
      provide: UserAddressAdapter,
      useClass: CustomOccUserAddressAdapter
    },
    {
      provide: CustomUserAddressAdapter,
      useClass: CustomOccUserAddressAdapter
    },
    {
      provide: CustomStoreFinderAdapter,
      useClass: CustomOccStoreFinderAdapter
    },
    {
      provide: CustomCartAdapter,
      useClass: CustomOccCartAdapter
    },
    {
      provide: CartAdapter,
      useClass: OccCartAdapter
    },
    {
      provide: PageLinkService,
      useClass: CustomPageLinkService
    },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    ActiveCartService
  ]
})
export class SpartacusConfigurationModule {}
